import apiClient from 'api/apiClient';

export const getIssuingBanks = () => apiClient.get('/v1/issuing_banks');

export const parseIssuingBanks = data => data?.data?.data;
